export { default } from "www/pages/sponsors/Sponsors";
